import { Button, EyeIcon, Paragraph } from "@datagame/ui";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import styles from "./ShowPreviewForm.module.scss";

const RESPONDER_URL = import.meta.env.VITE_RESPONDER_URL;

export interface ShowPreviewFormProps {
  projectId: string;
}

export const ShowPreviewForm = ({ projectId }: ShowPreviewFormProps) => {
  const { t } = useTranslation();

  const previewProjectLink = useMemo(() => {
    return `${RESPONDER_URL}/${projectId}?preview=true`;
  }, [projectId]);

  return (
    <div className={styles.preview}>
      <Paragraph color="secondary">{t("project:gameResults.showPreviewDescription")}</Paragraph>

      <a href={previewProjectLink} target="_blank" rel="noreferrer" className={styles.previewButtonLink}>
        <Button icon={<EyeIcon />} iconSide="left" kind="outline" className={styles.previewButton}>
          {t("project:gameResults.showPreview")}
        </Button>
      </a>
    </div>
  );
};
